// Shared timer screen (M55.4, ARCH §30.3, COW-4). Pomodoro 25 / Break 5 /
// Custom… / Stop. Client-only (ENG-1) — the face itself counts down from the
// sim clock (`sim/coworking/timer.ts` `timerFace`), so no frame here has to
// carry the remaining time.
import { h } from '../h';
import type { TimerData, TimerPreset } from '../../../sim/coworking/timer';

/** Open the timer picker; `onStart(preset, customTicks?)` / `onStop()` apply the
 *  change. `current` is read only to label the modal (no live face here — the
 *  in-world block face already reads it every frame). Returns a close handle. */
export function openTimerScreen(
  current: TimerData, onStart: (preset: TimerPreset, customTicks?: number) => void, onStop: () => void,
): () => void {
  const pomodoro = h('button', { class: 'bb-btn' }, 'Pomodoro 25');
  const brk = h('button', { class: 'bb-btn' }, 'Break 5');
  const custom = h('button', { class: 'bb-btn' }, 'Custom…');
  const customInput = h('input', { class: 'bb-timer-custom', type: 'number', placeholder: 'minutes', min: '1' });
  customInput.style.cssText = 'display:none;margin:8px 0;padding:4px;width:100px;';
  const customGo = h('button', { class: 'bb-btn' }, 'Start');
  customGo.style.display = 'none';
  const stop = h('button', { class: 'bb-btn' }, 'Stop');
  const close_ = h('button', { class: 'bb-btn' }, 'Close');
  const panel = h('div', { class: 'bb-timer-editor' },
    h('div', { class: 'bb-timer-title' }, `Timer (${current.preset})`),
    pomodoro, brk, custom, customInput, customGo, stop, close_);
  panel.style.cssText = 'background:#2b2b2b;color:#fff;padding:16px;border:2px solid #000;text-align:center;';
  const overlay = h('div', { class: 'bb-modal bb-timer-modal' }, panel);
  overlay.style.cssText = 'position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;background:#0006;';
  document.body.append(overlay);

  const closeFn = (): void => { overlay.remove(); };
  pomodoro.addEventListener('click', () => { onStart('pomodoro25'); closeFn(); });
  brk.addEventListener('click', () => { onStart('break5'); closeFn(); });
  custom.addEventListener('click', () => { customInput.style.display = 'inline-block'; customGo.style.display = 'inline-block'; });
  customGo.addEventListener('click', () => {
    const min = Number(customInput.value);
    if (min > 0) onStart('custom', Math.round(min * 60 * 20));
    closeFn();
  });
  stop.addEventListener('click', () => { onStop(); closeFn(); });
  close_.addEventListener('click', closeFn);
  return closeFn;
}
